<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { base } from '$app/paths';
    import { getBorderRadius } from '$lib/global/helper/border-radius';
    import { getCookiePreferences, setCookiePreferences } from '$lib/helper';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';
    import { cn } from '$lib/utils/cn';

    import translations from './translations';

    import type { Language } from '$lib/types/Language';

    export let campaignId = '';
    export let campaignVersionId = '';
    export let language: Language = 'en';
    export let bgColor = 'transparent';
    export let layout = DEFAULT_LAYOUT;

    const { isInFramedColumn, isInColumn } = layout;

    const handleAccept = () => {
        const cookies = getCookiePreferences(campaignId, campaignVersionId);

        const updatedCookies = Object.assign({}, cookies);
        updatedCookies.Media = true;

        setCookiePreferences(campaignId, campaignVersionId, updatedCookies);

        $mediaCookiesAccepted = true;
    };

    const videoBorderRadiusClass = getBorderRadius('video');
    const buttonBorderRadiusClass = getBorderRadius('button');
</script>

<div class="fun-font-sans" style:background={bgColor}>
    <div
        class={cn(
            'fun-relative fun-mx-auto fun-aspect-video fun-w-full fun-max-w-[448px] fun-bg-cover fun-bg-no-repeat lg:fun-max-w-[608px]',
            videoBorderRadiusClass,
            {
                'max-sm:fun-rounded-none': !layout.isInFramedColumn,
                'fun-w-[calc(100%+32px)] fun--translate-x-4 max-[448px]:fun-w-full max-[448px]:fun-translate-x-0 sm:fun-w-full sm:fun-translate-x-0':
                    !isInFramedColumn && isInColumn,
            },
        )}
        style="background-image: url('https://perspective.imgix.net/assets/app/wizardfactory/mediabg.jpg?auto=compress')"
    >
        <div
            class="fun-absolute fun-left-0 fun-top-0 fun-flex fun-h-full fun-w-full fun-flex-col fun-items-center fun-justify-center fun-gap-2 fun-p-2 fun-text-white sm:fun-gap-4"
        >
            <div class="fun-w-[12%]">
                <svg
                    width="100%"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g filter="url(#filter0_d)">
                        <circle
                            cx="17"
                            cy="16"
                            r="15"
                            fill="black"
                            fill-opacity="0.1"
                            stroke="white"
                            stroke-width="2"
                        />
                        <path
                            d="M14.5 19.1925V12.1155C14.5 11.271 15.4821 10.8068 16.1347 11.3428L20.5382 14.9599C21.0321 15.3656 21.0238 16.1241 20.5213 16.519L16.1178 19.9789C15.4617 20.4944 14.5 20.027 14.5 19.1925Z"
                            fill="white"
                        />
                    </g>
                    <defs>
                        <filter
                            id="filter0_d"
                            x="0"
                            y="0"
                            width="34"
                            height="34"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                        >
                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                            <feColorMatrix
                                in="SourceAlpha"
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="0.5" />
                            <feColorMatrix
                                type="matrix"
                                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            />
                            <feBlend
                                mode="normal"
                                in2="BackgroundImageFix"
                                result="effect1_dropShadow"
                            />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="effect1_dropShadow"
                                result="shape"
                            />
                        </filter>
                    </defs>
                </svg>
            </div>
            <span class="fun-px-4 fun-text-center fun-text-sm">
                {translations[language].cta}
                <a
                    href={`${base}/consent-policy`}
                    class="fun-text-white fun-underline hover:fun-text-gray-300"
                    >{translations[language].cookies}</a
                >
            </span>
            <button
                class={cn(
                    'fun-top-4 fun-flex fun-h-10 fun-items-center fun-justify-center fun-bg-blue-600 fun-px-4 fun-text-sm fun-text-white fun-transition-colors  hover:fun-bg-blue-700',
                    buttonBorderRadiusClass,
                )}
                on:click={handleAccept}>{translations[language].accept}</button
            >
        </div>
    </div>
</div>
